module.exports = __webpack_public_path__ + "img/GooglePlay.b6b7e257.png";